import repository from '@/repositories/Repository'

export default {
  async upload(file, inputName) {
    try {
      const formData = new FormData()
      formData.append('file', file)

      if (inputName) {
        formData.append('inputName', inputName.trim())
      }

      const response = await repository.giggle.post(
        `/api/user-customer-attributes/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      return response.data
    } catch (error) {
      if (error.response.status === 400) {
        return null
      }
      throw error
    }
  },
  get() {
    return repository.giggle
      .get(`/api/user-customer-attributes/input-names`)
      .then(r => r.data)
  },
  delete(inputName) {
    return repository.giggle
      .delete(`/api/user-customer-attributes/input-names/input-name`, {
        params: { inputName },
      })
      .then(r => r.data)
  },
}
